import { forwardRef, createElement } from 'react';

function IconProjects(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 3a1 1 0 00-.993.883L11 6v6.02l.01.118.022.113.023.077.03.075.047.093.062.096.07.085.072.071.096.075.099.06.075.036 3.5 1.5.11.04a1 1 0 00.782-1.826l-.104-.052L13 11.34V6l-.007-.117A1 1 0 0012 5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Projects = /*#__PURE__*/forwardRef(IconProjects);

export default Projects;
//# sourceMappingURL=Projects.js.map
